module.exports = __webpack_public_path__ + "staticVue/img/login-context-bg.8ee74ba1.png";